import React, { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { pastries } from '../mock';
import FicheModal from './FicheModal';
import { useLang } from '../LanguageContext';
import { useTheme } from '../ThemeContext';

const Pastries = () => {
  const [selected, setSelected] = useState(null);
  const { t, pastriesSubs } = useLang();
  const theme = useTheme();

  return (
    <section id="pastries" className="bg-[#f6ecd9] py-28">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-10 mb-20">
          <div className="md:col-span-3">
            <p className="text-[11px] tracking-[0.35em] uppercase text-[#d4a94c] mb-6">
              {t.pastries.eyebrow}
            </p>
            <h2 className="font-serif text-5xl md:text-6xl text-[#0d1b36] leading-[1.08]">
              {t.pastries.t1}<br />
              <em className="italic font-light">{t.pastries.t2}</em>
            </h2>
          </div>
          <div className="md:col-span-2 md:pt-20">
            <p className="text-[#0d1b36]/70 text-base leading-relaxed">
              {t.pastries.desc}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
          {pastries.map((item, idx) => (
            <button
              key={item.id}
              onClick={() => setSelected({ ...item, subtitle: pastriesSubs[idx] })}
              className={`group text-left cursor-pointer ${idx % 2 === 1 ? 'md:translate-y-14' : ''}`}
            >
              <div className="relative overflow-hidden rounded-xl aspect-[4/3]" style={{ background: theme.primary05 }}>
                <div
                  className="absolute top-4 left-4 z-10 px-3 py-1 rounded-full backdrop-blur text-[#f6ecd9] text-[10px] tracking-[0.3em] uppercase"
                  style={{ background: theme.primary85 }}
                >
                  N°{item.num}
                </div>
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  style={item.imagePosition ? { objectPosition: item.imagePosition } : undefined}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d1b36]/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
              <div className="flex items-start justify-between mt-5">
                <div>
                  <h3 className="font-serif text-2xl text-[#0d1b36] mb-1 group-hover:text-[#d4a94c] transition-colors">
                    {item.name}
                  </h3>
                </div>
                <span className="flex items-center gap-1 text-[#d4a94c] text-[10px] tracking-[0.3em] uppercase pt-1 group-hover:gap-2 transition-all">
                  {t.pastries.fiche}
                  <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={2} />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>

      <FicheModal
        open={!!selected}
        onClose={() => setSelected(null)}
        item={selected}
        type="pastry"
      />
    </section>
  );
};

export default Pastries;
